"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var WordsCaseService = /** @class */ (function () {
    function WordsCaseService() {
    }
    WordsCaseService.kebabCaseToCamelCase = function (str) {
        var capitalizeFirstChar = function (str) { return ramda_1.toUpper(ramda_1.head(str)) + ramda_1.tail(str); };
        return str
            .split('-')
            .map(function (word, index) { return (index ? capitalizeFirstChar(word) : word); })
            .join('');
    };
    WordsCaseService.camelCaseToKebabCase = function (str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    };
    return WordsCaseService;
}());
exports.WordsCaseService = WordsCaseService;
//# sourceMappingURL=wordsCaseService.js.map